import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';

@Component({
  selector: 'app-level',
  templateUrl: './level.component.html',
  styleUrls: ['./level.component.scss']
})
export class LevelComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TABS.LEVEL;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['id']];
      const { selectedCompanyKey } = this.auth;
      this.store.fetchData(COLLECTION_NAME.LEVEL, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey)
    })
  }

  create() {
    this.router.navigate([`/levels/level-form/draft`])
  }

  edit(item: any) {
    this.router.navigate([`/levels/level-form/${item.key}`])
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.delete(COLLECTION_NAME.LEVEL, item, (success) => {
          if (success) {
            this.snackBar.open("Level has been deleted successful.", "Done", { duration: 2500 });
          }
        })
      }
    });
  }
}
